import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AuthProvider } from "@/auth/AuthProvider";
import { ClientDetailPage } from "@/routes/ClientDetailPage";
import { DashboardPage } from "@/routes/DashboardPage";
import { LoginPage } from "@/routes/LoginPage";
import { OnboardingDetailPage } from "@/routes/OnboardingDetailPage";
import { OnboardingListPage } from "@/routes/OnboardingListPage";
import { OnboardingNewPage } from "@/routes/OnboardingNewPage";
import { ProtectedRoute } from "@/routes/ProtectedRoute";
import { SettingsPage } from "@/routes/SettingsPage";

export function makeQueryClient(): QueryClient {
	return new QueryClient({
		defaultOptions: {
			queries: {
				retry: 1,
				refetchOnWindowFocus: false,
			},
		},
	});
}

export interface AppProps {
	queryClient?: QueryClient;
}

export function App({ queryClient = makeQueryClient() }: AppProps) {
	return (
		<QueryClientProvider client={queryClient}>
			<BrowserRouter>
				<AuthProvider>
					<Routes>
						<Route path="/login" element={<LoginPage />} />
						<Route
							path="/"
							element={
								<ProtectedRoute>
									<DashboardPage />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/clients/:id"
							element={
								<ProtectedRoute>
									<ClientDetailPage />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/settings"
							element={
								<ProtectedRoute>
									<SettingsPage />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/onboarding"
							element={
								<ProtectedRoute>
									<OnboardingListPage />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/onboarding/new"
							element={
								<ProtectedRoute>
									<OnboardingNewPage />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/onboarding/:id"
							element={
								<ProtectedRoute>
									<OnboardingDetailPage />
								</ProtectedRoute>
							}
						/>
						<Route path="*" element={<Navigate to="/" replace />} />
					</Routes>
				</AuthProvider>
			</BrowserRouter>
		</QueryClientProvider>
	);
}
